import { on } from '@ember/modifier';
import { concat } from '@ember/helper';
import { t } from 'ember-intl';
import { eq } from 'ember-truth-helpers';
import { HdsFormSelectField } from '@hashicorp/design-system-components/components';

const SsoFormInputDefaultRoleSelect = <template>
  <HdsFormSelectField
    data-test-sso-form-input-default-role-select
    {{on "input" @handleDefaultRoleChange}}
    as |F|
  >
    <F.Label>
      {{t "sso.form-input.default-role-select.label"}}
    </F.Label>

    <F.Options>
      {{#each @roleOptions as |role|}}
        {{#if (eq role @selectedRole)}}
          <option value={{role}} selected>
            {{t (concat "sso.default-role-display." role)}}
          </option>
        {{else}}
          <option value={{role}}>
            {{t (concat "sso.default-role-display." role)}}
          </option>
        {{/if}}
      {{/each}}
    </F.Options>
  </HdsFormSelectField>
</template>;
export default SsoFormInputDefaultRoleSelect;
